import { Page } from "@/models/page-models/Page";

export const MiscInvoiceView: Page = {
  "path": "misc-invoice/:invoiceId",
  "name": "Miscellaneous Invoice",
  "props": {
    "data": {
      "title": "Tax Invoice",
      "printable": "fn(NOT,fn(NOT,{{formData.invoiceData.data.qr}}))",
      "url": "misc-invoice/:invoiceId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "custom_InvoiceDetails",
                  "variable": "formData.invoiceData.data",
                  "label": "Invoice Details",
                  "disabled": "FALSE",
                  "showIf": "{{formData.invoiceData.data}}",
                  "config": {
                    "customerDetailsVariable": "formData.invoiceData.data.customer.id",
                    "billingAddressKey": "billingAddress"
                  }
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Invoice Orders",
                  "disabled": "FALSE",
                  "showIf": "{{formData.invoiceData.data.orders}}",
                  "items": "formData.invoiceData.data.orders",
                  "headers": [
                    {
                      "value": "slNo",
                      "text": "#",
                      "width": 40,
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{formData.invoiceData.data.orders}}))"
                    },
                    {
                      "value": "order",
                      "text": "Order #\\n# حزمة",
                      "type": "formula",
                      "formula": "N/A",
                      "width": 70
                    },
                    {
                      "value": "description",
                      "text": "Description\\nالتفاصيل",
                      "width": 200
                    },
                    {
                      "value": "sellingUnit",
                      "text": "Unit\\nالوحدة",
                      "width": 61
                    },
                    {
                      "value": "quantity",
                      "text": "Quantity\\nالكمية",
                      "width": 76
                    },
                    {
                      "value": "unitPrice",
                      "text": "Price\\nالسعر",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,unitPriceFormat,fn(DIVIDE,{{__item.value}},{{__item.quantity}}))",
                      "width": 58
                    },
                    {
                      "value": "value",
                      "text": "Sub Total\\nالمجموع الفرعي",
                      "formula": "fn(HELPER_FN,currency,{{__item.value}})",
                      "width": 110
                    },
                    {
                      "value": "vatRate",
                      "text": "VAT %\\nالضريبة %",
                      "type": "formula",
                      "formula": "{{fetchedData.vatPercent}} %",
                      "width": 79
                    },
                    {
                      "value": "vatValue",
                      "text": "VAT Value\\nقيمة الضريبة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.value}},{{fetchedData.vatPercent}},0.01))",
                      "width": 91
                    },
                    {
                      "value": "total",
                      "text": "Total + VAT\\nالمجموع + الضريبة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.value}},fn(SUM,100,{{fetchedData.vatPercent}}),0.01))",
                      "width": 120
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "fontSize": "0.75rem;"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "custom_InvoiceTotal",
                  "variable": "formData.invoiceData.data.orders",
                  "label": "Sub Total",
                  "disabled": "FALSE",
                  "config": {
                    "subTotalFormula": "{{formData.invoiceData.data.subtotal}}",
                    "totalFormula": "{{formData.invoiceData.data.total}}",
                    "companyDetails": "{{fetchedData.companyDetails.data.0.data}}",
                    "docDetails": "{{formData.invoiceData.data}}",
                    "showQrCode": true,
                    "qrCodeVariable": "formData.invoiceData.data.qr",
                    "vatVariable": "{{fetchedData.vatPercent}}"
                  }
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Clear Invoice",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "clearInvoice",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/e-invoicing/clear-misc-invoice/{{__params.invoiceId}}?type=Invoice",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "GET"
                      },
                      "name": "clearInvoice"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(NOT,{{formData.invoiceData.data.qr}})",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.invoiceData.data.status}},'),==,'Approved')",
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print Invoice",
                  "buttonType": "print",
                  "disabled": "FALSE",
                  "showIf": "fn(NOT,fn(NOT,{{formData.invoiceData.data.qr}}))",
                  "color": "primary"
                }
              ],
              "showIf": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{formData.invoiceData.data.status}},'),!=,'Pending')"
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true,
      "arabicTitle": "فاتورة ضريبية",
      "printDocDate": "{{formData.invoiceData.data.createdAt}}"
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMiscellaneousInvoice",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/misc-invoice/{{__params.invoiceId}}",
          "arg2Key": "storeInVar",
          "arg2Value": "formData.invoiceData"
        },
        "name": "getMiscellaneousInvoice"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCompanyDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=company-detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.companyDetails"
        },
        "name": "getCompanyDetails"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyVatPercentage",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getVatPercentage",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyVatPercentage"
      }
    ],
    "functions": [
      {
        "name": "getVatPercentage",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "vatPercent": "fn(CONDITIONAL,{{formData.invoiceData.data.customer.id.exportCustomer}},0,{{fetchedData.companyDetails.data.0.data.vatPercentage}})"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,GENERAL_MANAGER",
  "visible": false
}